<div class="container">
    <div class="header">
        <mat-expansion-panel [expanded]="panelOpenState" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <mat-icon>filter_alt</mat-icon>
                    Filters
                </mat-panel-title>
                <mat-panel-description>
                    Choose your search filters
                </mat-panel-description>
            </mat-expansion-panel-header>
            <season-metrics-filters-component></season-metrics-filters-component>
        </mat-expansion-panel>
    </div>
    <div class="spinner"><mat-spinner [diameter]="30" *ngIf="submitted"></mat-spinner> </div>
    @if(tableLoaded){
    <div class="responsive_table">
        <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)" class="mat-elevation-z8">        
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by name">
                    Name
                </th>
                <td mat-cell *matCellDef="let element"> {{element.player_id.name}} </td>
            </ng-container>
            <ng-container matColumnDef="season">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by season">
                    Season
                </th>
                <td mat-cell *matCellDef="let element"> {{element.season}} </td>
            </ng-container>
            <ng-container matColumnDef="games_played">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by games played">
                    Games Played
                </th>
                <td mat-cell *matCellDef="let element"> {{element.games.played}} </td>
            </ng-container>
            @for (m of this.service.metricsSelected; track m) {
            <ng-container matColumnDef={{m.field}}>
                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by {{m.label}}">
                    {{m.label}}
                </th>
                <td mat-cell *matCellDef="let element"> {{m | getValuePipe:element | number:'1.0-2' }} </td>
            </ng-container>
            }
    
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
    <mat-paginator #paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons aria-label="Select page"></mat-paginator>
    }
</div>